import Modal from "react-bootstrap/Modal";
import { Button } from "../..";

import styles from "./styles.module.css";

export const DeleteConfirmModal = (props) => {
    const { isOpen, closeModal, itemToDelete, onConfirmDelete } = props;

    return (
        <Modal show={isOpen} onHide={closeModal} dialogClassName={styles.modal}>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Delete</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <p>
                    Are you sure you want to delete the item{" "}
                    <strong>'{itemToDelete?.name}'</strong>?
                </p>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    style={{
                        width: "100px",
                        backgroundColor: "#6c757d",
                        borderColor: "#6c757d",
                    }}
                    onClick={closeModal}
                >
                    Cancel
                </Button>
                <Button
                    style={{
                        width: "100px",
                        backgroundColor: "#dc3545",
                        borderColor: "#dc3545",
                    }}
                    onClick={() => {
                        onConfirmDelete(itemToDelete);
                        closeModal();
                    }}
                >
                    Delete
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
